<template>
  <div class="member-container">
    <!-- ===== 筛选区域 ===== -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="手机号">
          <el-input v-model="filterForm.mem_user" placeholder="请输入手机号" clearable />
        </el-form-item>
        <!-- <el-form-item label="会员名称">
          <el-input v-model="filterForm.mem_name" placeholder="请输入会员名称" clearable />
        </el-form-item> -->
        <!-- <el-form-item label="会员类型">
          <el-select v-model="filterForm.mem_type" placeholder="全部" clearable>
            <el-option label="团长" value="团长" />
            <el-option label="VIP" value="VIP" />
            <el-option label="普通" value="普通" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.mem_status" placeholder="全部" clearable>
            <el-option label="正常" value="正常" />
            <el-option label="禁用" value="禁用" />
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- ===== 列表卡片 ===== -->
    <el-card class="table-card" shadow="never" >
      <el-table
        v-loading="loading"
        :data="memberList"
        height="56vh"
        border
        stripe
        style="width: auto;max-width: 1300px;margin: auto;"
        @row-click="showDetail"
      >
        <el-table-column prop="id" label="ID" width="80" align="center" />
        <el-table-column prop="mem_user" label="手机号" width="200" />
        <el-table-column prop="mem_dian" label="会员名称" width="180" />
        <!-- <el-table-column prop="mem_nick" label="昵称" min-width="120" /> -->
        <!-- <el-table-column prop="mem_dian" label="店铺名称" min-width="150" show-overflow-tooltip /> -->
        <!-- <el-table-column prop="mem_type" label="会员类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getMemberTypeTag(scope.row.mem_type)" size="small">
              {{ scope.row.mem_type }}
            </el-tag>
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="mem_status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.mem_status === '正常' ? 'success' : 'danger'" size="small">
              {{ scope.row.mem_status }}
            </el-tag>
          </template>
        </el-table-column> -->
        <el-table-column prop="mem_num" label="订单数" width="100" align="center" />
        <el-table-column prop="mem_rank" label="等级" width="80" align="center" />
        <el-table-column prop="comlist3" label="创建时间" width="250" />
        <el-table-column label="操作" min-width="200" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" icon="el-icon-view" @click.stop="showDetail(scope.row)">
              详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- ===== 详情弹窗 ===== -->
    <el-dialog
      title="会员详情"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      @close="dialogVisible = false"
    >
      <el-descriptions v-if="currentMember" :column="2" border class="detail-descriptions">
        <el-descriptions-item label="ID">{{ currentMember.id }}</el-descriptions-item>
        <!-- <el-descriptions-item label="会员类型">
          <el-tag :type="getMemberTypeTag(currentMember.mem_type)" size="small">
            {{ currentMember.mem_type }}
          </el-tag>
        </el-descriptions-item> -->
        <el-descriptions-item label="手机号">{{ currentMember.mem_user }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="currentMember.mem_status === '正常' ? 'success' : 'danger'" size="small">
            {{ currentMember.mem_status }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="会员名称">{{ currentMember.mem_dian }}</el-descriptions-item>
        <!-- <el-descriptions-item label="昵称">{{ currentMember.mem_nick || '-' }}</el-descriptions-item> -->
        <!-- <el-descriptions-item label="店铺名称">{{ currentMember.mem_dian || '-' }}</el-descriptions-item> -->
        <!-- <el-descriptions-item label="等级">{{ currentMember.mem_rank }}</el-descriptions-item> -->
        <!-- <el-descriptions-item label="会员码">{{ currentMember.mem_code || '-' }}</el-descriptions-item> -->
        <el-descriptions-item label="累计订单数">{{ currentMember.mem_num || 0 }}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ currentMember.comlist3 }}</el-descriptions-item>
        <el-descriptions-item label="更新时间">{{ currentMember.comlist4 || '-' }}</el-descriptions-item>
        <el-descriptions-item label="地址">{{ currentMember.comlist_v2 || '-' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ currentMember.comlist_v1 || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'MemberList',
  data () {
    return {
      loading: false,
      memberList: [],
      filterForm: {
        mem_user: '',
        mem_name: '',
        mem_type: '',
        mem_status: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      currentMember: null
    }
  },
  mounted () {
    this.fetchMemberList()
  },
  methods: {
    // ---------- 获取列表 ----------
    async fetchMemberList (keepPage = false) {
      if (!keepPage) this.currentPage = 1

      this.loading = true
      try {
        const params = {
          a: 'crmlists',
          sh_id: parseInt(localStorage.getItem('sh_id')),
          page: this.currentPage,
          page_size: this.pageSize,
          ...this.filterForm
        }
        // 删除空字符串参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })

        const res = await request.post('/admin/crm_list.php', params)
        console.log(res)
        if (res.code === '0') {
          const list = res.list || res.data || []
          this.memberList = list.map(item => {
            if (item.crm_main) {
              const main = item.crm_main
              return {
                ...item,
                mem_user: main.mem_user,
                mem_name: main.mem_name,
                mem_nick: main.mem_nick,
                mem_dian: main.mem_dian,
                mem_type: main.mem_type,
                mem_rank: main.mem_rank,
                mem_code: main.mem_code,
                mem_num: main.mem_num,
                comlist4: main.comlist4,
                comlist_v1: main.comlist_v1,
                comlist_v2: main.comlist_v2,
                // 保留 crm_main 完整对象以备详情使用
                crm_main: main
              }
            }
            return item
          })
          this.total = res.total || 0
        } else {
          this.$message.error(res.msg || '获取会员列表失败')
          this.memberList = []
          this.total = 0
        }
      } catch (error) {
        console.error('请求会员列表出错:', error)
        this.$message.error('网络错误，请稍后重试')
        this.memberList = []
        this.total = 0
      } finally {
        this.loading = false
      }
    },

    // ---------- 搜索 / 重置 ----------
    handleSearch () {
      this.fetchMemberList()
    },
    handleReset () {
      this.filterForm = {
        mem_user: '',
        mem_name: '',
        mem_type: '',
        mem_status: ''
      }
      this.currentPage = 1
      this.fetchMemberList()
    },

    // ---------- 分页 ----------
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchMemberList(true)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchMemberList(true)
    },

    // ---------- 详情 ----------
    showDetail (row) {
      this.currentMember = row
      this.dialogVisible = true
    },

    // ---------- 工具 ----------
    getMemberTypeTag (type) {
      const map = {
        团长: 'warning',
        VIP: 'success',
        普通: 'info'
      }
      return map[type] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
.member-container {
  padding: 0 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .detail-descriptions {
    margin-bottom: 10px;
  }
}
</style>
